import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function OgrnView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const files = currentApplication?.files || [];
  const registry_subject = currentApplication?.registry_subject || {};

  const { ogrn } = applicant_new;
  const ogrn_change_document = files.find(item => item.collection_name === 'ogrn_change_document');

  const {
    ogrn: oldOgrn,
  } = registry_subject;

  const hasOgrnData = !!ogrn || ogrn === null;

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) || applicantType !== USER_TYPE.LEGAL) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOgrnData,
            }}
            label="Изменился ОГРН"
          />
        </Col>
      </Row>
      {hasOgrnData && (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'old.ogrn',
              oldOgrn,
              fieldsValidation,
              'ogrn',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.ogrn',
              ogrn,
              fieldsValidation,
              'applicant_new.ogrn',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.ogrn_change_document',
              ogrn_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[ogrn_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
